module.exports = __webpack_public_path__ + "static/img/fahuode52669.png";